module.exports = __webpack_public_path__ + "static/media/ddad6043-80e4-14dd-e9ac-f65b938c9740.b9d5aa5d.jpg";